
import { TableCell, TableRow } from "@/components/ui/table";
import { SchoolUser } from "@/types/users";
import { UserApprovalSwitch } from "./UserApprovalSwitch";
import { UserActions } from "./UserActions";

interface UserTableRowProps {
  user: SchoolUser & {
    hasUnpaidBills?: boolean;
    hasActiveSubscription?: boolean;
  };
  onDelete: (user: SchoolUser) => void;
  onUserUpdated: () => void;
}

export const UserTableRow = ({ user, onDelete, onUserUpdated }: UserTableRowProps) => {
  return (
    <TableRow>
      <TableCell>{user.email}</TableCell>
      <TableCell>{user.mobile_number || "-"}</TableCell>
      <TableCell className="capitalize">{user.role}</TableCell>
      <TableCell>{user.school_id}</TableCell>
      <TableCell>
        <UserApprovalSwitch user={user} onUserUpdated={onUserUpdated} />
      </TableCell>
      <TableCell>
        <UserActions
          user={user}
          onDelete={onDelete}
          onUserUpdated={onUserUpdated}
        />
      </TableCell>
    </TableRow>
  );
};
